import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M4.05 13.95H5.00625L12.0375 6.91875L11.0812 5.9625L4.05 12.9937V13.95ZM3.37837'
  + ' 15.3C3.18862 15.3 3.02813 15.2356 2.89688 15.1069C2.76563 14.9782 2.7 14.8187 2.7'
  + ' 14.6284V12.9999C2.7 12.8208 2.73125 12.65 2.79375 12.4875C2.85625 12.325 2.95625 12.175 3.09375'
  + ' 12.0375L12.0375 3.09375C12.175 2.95625 12.324 2.85625 12.4845 2.79375C12.6449 2.73125 12.8136'
  + ' 2.7 12.9907 2.7C13.1677 2.7 13.3375 2.73125 13.5 2.79375C13.6625 2.85625 13.8125 2.95625 13.95'
  + ' 3.09375L14.9062 4.05C15.0437 4.1875 15.1437 4.3375 15.2062 4.5C15.2687 4.6625 15.3 4.82837 15.3'
  + ' 4.99762C15.3 5.17825 15.2686 5.35038 15.2059 5.514C15.1431 5.67763 15.0432 5.82713 14.9062'
  + ' 5.9625L5.9625 14.9062C5.825 15.0437 5.67531 15.1437 5.51344 15.2062C5.35156 15.2687 5.18131 15.3'
  + ' 5.00269 15.3H3.37837ZM11.5509 6.44906L11.0812 5.9625L12.0375 6.91875L11.5509 6.44906Z'

const EditIcon = ({ className, title, onClick }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    role="img"
    aria-label={title}
    onClick={onClick}
  >
    <path d={PATH} fill="currentColor" />
  </svg>
)

EditIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

EditIcon.defaultProps = {
  className: '',
  onClick: null,
  title: ''
}

export default EditIcon
